import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TgBoxes2Module, TgGridModule } from '@trademe/tangram';
import { ResidentialForSaleAgentSummaryPageSummarySectionComponent } from './summary-page-summary-section.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TgGridModule,
        TgBoxes2Module
    ],
    declarations: [ResidentialForSaleAgentSummaryPageSummarySectionComponent],
    exports: [ResidentialForSaleAgentSummaryPageSummarySectionComponent]
})
export class ResidentialForSaleAgentSummaryPageSummarySectionModule {}
